import { useContext, useState } from "react";
import Api from "../axiosConfig";
import { AuthContext } from "../context/auth.context";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import"../style/navbar.css";

function Navbar() {
   
  const [searchTerm, setSearchTerm] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const { state, dispatch } = useContext(AuthContext);
  const [searchResults, setSearchResults] = useState([]);
  
  const router = useNavigate();
  // Handle logout
  const handleLogout = async () => {
   try {
     const response = await Api.post('/auth/logout');
     if (response.data.success) {
       dispatch({ type: 'LOGOUT' });
       router('/');
       toast.success(response.data.message);
     } else {
       toast.error('Logout failed.');
     }
   } catch (error) {
     toast.error('Failed to logout.');
   }
 };
  // Handle search
  const handleSearch = async () => {
   try {
     const response = await Api.post('/auth/search', { searchedWord: searchTerm });
     if (response.data.success) {
       setSearchResults(response.data.users);
       setIsPopupVisible(true);
     } else {
       toast.error('Search failed.');
     }
   } catch (error) {
     toast.error('Failed to search.');
   }
 };
return(
   <div className="navbar">
        <h1 className="logo">Instagram</h1>
        <h1 className="instralogo"></h1>

        <div className="Search">
          <div className="Search1">
            <i className="fa-solid fa-magnifying-glass" onClick={handleSearch}></i>
          </div>
          <div className="Search2">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
          </div>
        </div>



        <div className="Home">
          <div className="Home1">
            <i className="fa-solid fa-house"></i>
          </div>
          <div className="Home2">
            <p onClick={() => router("/home")}>Home</p>
          </div>
        </div>

        <div className="Explore">
          <div className="Explore1">
            <i className="fa-regular fa-compass"></i>
          </div>
          <div className="Explore2">
            <p>Explore</p>
          </div>
        </div>

        <div className="Reels">
          <div className="Reels1">
            <i className="fa-solid fa-play"></i>
          </div>
          <div className="Reels2">
            <p>Reels</p>
          </div>
        </div>

        <div className="Messages">
          <div className="Messages1">
            <i className="fa-solid fa-message"></i>
          </div>
          <div className="Messages2">
            <p>Messages</p>
          </div>
        </div>

        <div className="Notifications">
          <div className="Notifications1">
            <i className="fa-regular fa-heart"></i>
          </div>
          <div className="Notifications2">
            <p>Notifications</p>
          </div>
        </div>

        <div className="Create">
          <div className="Create1">
            <i className="fa-regular fa-square-plus"></i>
          </div>
          <div className="Create2">
            <p onClick={() => router("/create-post")}>Create</p>
          </div>
        </div>

        <div className="Profile" onClick={() => router(`/profile/${state?.user?.userId}`)}>
          <div className="Profile1">
            <i className="fa-regular fa-user"></i>
          </div>
          <div className="Profile2">
            <p>Profile</p>
          </div>
        </div>

        <div className="More">
          <div className="More1">
            <i className="fa-solid fa-bars"></i>
          </div>
          <div className="More2">
            <p>More</p>
          </div>
        </div>

        
        <div className="logout">
          <div className="logout1">
            <i className="fa-regular fa-user"></i>
          </div>
          <div className="logout2" onClick={handleLogout}>
            <p>Logout</p>
          </div>
        </div>
        {isPopupVisible && (
        <div className="search-popup">
          <div className="popup-content">
            <span className="close-btn" onClick={() => setIsPopupVisible(false)}>×</span>
            <h2>Search</h2>
            {searchResults.length > 0 ? (
              <div className="search">
                {searchResults.map(user => (
                  <div key={user._id} className="search-result-item">
                    <img
                      className="profilePhotoSmall"
                      src={user.profilePicture || '/default-profile.png'}
                      alt={`${user.username}'s profile`}
                      onClick={() => router(`/profile/${user._id}`)}
                    />
                    <span className="username"
                     onClick={() => router(`/profile/${user._id}`)}>{user.username}</span>
                  </div>
                ))}
              </div>
            ) : (
              <p>No users found.</p>
            )}
          </div>
        </div>
      )}
      </div>

)

    
}
   export default Navbar;